import FilterStore from "../abstract.filter.store";
import {OtherCompanyModuleServiceInterface, OtherCompanyModuleStoreInterface,} from "../../types";
import {ActionEnum, ResponseTypeEnum, TranslationDomainEnum} from "../../types/enums";
import {action, makeObservable, observable, runInAction} from "mobx";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";
import {OtherCompanyListItem} from "../../types/modules/otherCompanu/modules";
import {OtherCompanyAddRequest, OtherCompanyEditRequest, OtherCompanyPrepareEditFormRequest, OtherCompanyViewRequest} from "../../types/modules/otherCompanu/request";

export default class OtherCompanyStore extends FilterStore implements OtherCompanyModuleStoreInterface {
    public _items: OtherCompanyListItem[] = [];

    readonly _module: string = 'other_company'

    readonly _headers: string[] = [
        'name', 'phone', 'email', 'addressString', 'iban', 'disabled'
    ]

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT
    ]

    constructor(
        private readonly appStore: AppStore,
        private readonly service: OtherCompanyModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }

    public list = async () => {
        runInAction(() => {
            this.loading = true;
        });

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = async (request: OtherCompanyEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('otherCompany.message.other_company_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public view = async (request: OtherCompanyViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public add = async (request: OtherCompanyAddRequest) => {
        this.appStore.setLoading(true);
        return this.service.add(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('otherCompany.message.other_company_add_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.COMPANY_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public prepareEditForm = async (request: OtherCompanyPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }

    public prepareAddForm = async () => {
        return this.service.prepareAddForm()
            .then(({data}) => {
                return data;
            });
    }
}